import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { forEach, isEmpty } from 'lodash';

import { WorkShiftStatusIntervals } from '../../employee-statuses/employee-worked/employee-worked.component';
import { Enums } from '../../../../../../configs/Enums';
import { AuthService } from '../../../../../auth/auth.service';

@Component({
  selector: 'app-monitoring-work-worked',
  templateUrl: './monitoring-work-worked.component.html',
  styleUrls: ['./monitoring-work-worked.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MonitoringWorkWorkedComponent implements OnChanges {
  public Enums = Enums;
  public moment = require('moment');
  public intervals = {};

  @Input() worked;
  @Input() currentDate;

  constructor(private cdr: ChangeDetectorRef, private authService: AuthService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.handleUpdate();
  }

  handleUpdate() {
    if (!this.worked || isEmpty(this.worked)) {
      return;
    }

    forEach(this.worked, (intervals, int_type) => {
      let millis = 0;
      let interval: WorkShiftStatusIntervals = {
        hours: 0,
        minutes: 0,
        int_type: +int_type,
        int_name: '',
      };

      forEach(intervals, (int) => {
        millis += +new Date(int.int_end) - +new Date(int.int_begin);
      });

      let timeObj = millis ? this.moment.duration(millis) : undefined;

      if (typeof timeObj === 'object') {
        interval.hours = timeObj.hours();
        interval.minutes = timeObj.minutes();
      }

      this.intervals[this.getStatus(int_type)] = interval;
    });

    this.cdr.markForCheck();
  }

  private getStatus = (intType: string) => {
    const mapper = this.authService.isGRSUser()
      ? Enums.workShiftTicketsIntervalSquareGRS
      : Enums.workShiftTicketsIntervalSquare;

    return mapper[+intType];
  }
}
